import { createApp } from "vue";

import I18n from "../plugins/i18n";
import Business from "../pages/Business.vue";

document.addEventListener("DOMContentLoaded", () => {
  const node = document.getElementById("business-app");
  const props = JSON.parse(node.dataset.props);
  const translations = JSON.parse(node.dataset.translations);

  const app = createApp(Business, props);

  app.use(I18n, translations);

  app.mount(node);
});
